<template>
    <div v-if="error">
        <div :class="'bg-'+color+'-50 px-4 py-3 text-'+color+'-900 rounded-lg relative text-sm shadow-md error w-fit'">
            <div class="w-8 overflow-hidden inline-block absolute left-2 top-0 -mt-4">
            <div :class="'h-5 w-5 bg-'+color+'-50 rotate-45 transform origin-bottom-left'"></div>
            </div>
            <fa :icon="['fas', 'exclamation-triangle']" class="mr-2" />
            {{ error }}
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    error: {
        type: String,
        required: false,
    },
    color: {
        type: String,
        default: 'red',
        required: false,
    },
});
</script>